import { BroadcastMessageType } from './broadcast-message-type.model';

export interface BroadcastMessage {
  id: number;
  type: BroadcastMessageType;
  infoMessage: string;
  audioMessage: string;
  status: BroadcastMessageStatus;
  startDate: Date;
  endDate: Date;
}

export interface BroadcastMessageRequest {
  broadcastMessageTypeId: number;
  infoMessage: string;
  audioMessage: string;
}

export enum BroadcastMessageStatus {
  READY = 'READY',
  EXPIRED = 'EXPIRED',
  CANCELED = 'CANCELED',
}
